export enum StoryFilterFieldType {
  Custom = 0,
  Visiblity = 1,
  Tag = 2,
  State = 3,
}
